import {useContext, createContext} from 'react'

export const ModalContext = createContext()

export const useModalContext = () => {
    const context = useContext(ModalContext)
    if (!context) {
        throw new Error(
            "useModalContext must be used within a ModalProvider. Please ensure all modal-related components are nested within 'ModalContainer'"
        )
    }
    return context
}
